import React, { useState, useEffect } from 'react';
import { storage, ADMIN_PASSWORD } from '../utils/storage';
import './AdminMode.css';

interface AdminModeProps {
  onToggle: (isAdmin: boolean) => void;
  showLockButton?: boolean;
}

const AdminMode: React.FC<AdminModeProps> = ({ onToggle, showLockButton = true }) => {
  const [isAdmin, setIsAdmin] = useState(storage.isAdminMode());
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    onToggle(isAdmin);
  }, [isAdmin, onToggle]);

  const handleLockClick = () => {
    if (isAdmin) {
      // Çıkış yap
      storage.setAdminMode(false);
      setIsAdmin(false);
    } else {
      // Şifre girişi göster
      setShowPasswordInput(true);
    }
  };

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      storage.setAdminMode(true);
      setIsAdmin(true);
      setShowPasswordInput(false);
      setPassword('');
      setError('');
    } else {
      setError('Yanlış şifre!');
      setPassword('');
    }
  };

  const handleExit = () => {
    storage.setAdminMode(false);
    setIsAdmin(false);
  };

  return (
    <div className="admin-mode">
      {showLockButton && (
        <button className="lock-button" onClick={handleLockClick} title="Yönetici Modu">
          <img src="/icons/lock-icon.png" alt="Kilit" />
        </button>
      )}
      {isAdmin && (
        <>
          <button 
            className="refresh-button" 
            onClick={() => {
              if (window.confirm('Tüm önbellek temizlenecek ve sayfa yenilenecek. Eski veriler (İSMAİL/ONUR gibi senkronizasyon sorunları) düzelecektir. Devam?')) {
                storage.forceRefreshData();
              }
            }} 
            title="Verileri Yenile (Cache Temizle)"
          >
            🔄
          </button>
          <button className="exit-button" onClick={handleExit} title="Yönetici Modundan Çık">
            <img src="/icons/exit-icon.png" alt="Çıkış" />
          </button>
        </>
      )}
      {showPasswordInput && !isAdmin && (
        <div className="password-modal-overlay" onClick={() => {
          setShowPasswordInput(false);
          setPassword('');
          setError('');
        }}>
          <div className="password-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="password-modal-title">Yönetici Girişi</h2>
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                placeholder="Şifre giriniz"
                autoFocus
              />
              {error && <div className="error-message">{error}</div>}
              <div className="password-buttons">
                <button type="submit">Giriş</button>
                <button type="button" onClick={() => {
                  setShowPasswordInput(false);
                  setPassword('');
                  setError('');
                }}>
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminMode;



